export const HomeColophon = () => {
    return (
        <footer className="bg-[var(--color-primary-800)] px-6 py-12 sm:py-14">
            <div className="m-auto flex justify-center">
                <img
                    src="/savory-grimoire-sm.png"
                    alt=""
                    aria-hidden="true"
                    className="h-14 w-auto opacity-50 select-none [filter:invert(1)_brightness(2)]"
                />
            </div>
        </footer>
    );
};
